import React from 'react'

export default function Profile() {
  return (
    <section className="resume-section" id="profile">
      <div className="resume-section-content">
        <h2 className="mb-5">Profile Summary</h2>
        <div className="subheading mb-3"></div>
        <ul>
          <li>
            Currently working as a Consultant in ATOS-SYNTEL with 12+ years of experience in technical analysis, application and product development and maintenance.
          </li>
          <li>
            Good working knowledge on Application development life cycle.
          </li>
          <li>
            Good Knowledge and experience in OOP concepts, SOLID, Design Pattern, TDD
          </li>
          <li>
            Good Knowledge and experience in ReactJs, NodeJs, C#.Net, ASP. NET, ADO.NET,LINQ, MVC, NET CORE, SQL, SQL Server, JavaScript, jQuery, CSS, and HTML.

          </li>
          <li>
            Other technical stack includes Web Service and Web API.
          </li>
          <li>
            Experience developing within an Agile development. Excellent trouble shooting techniques.

          </li>
          <li>
            Good at interpreting the functional – technical relationship & charting the requirements.

          </li>
          <li>
            An upbeat individual with a logical approach to challenges, performing effectively within a highly pressurized working environment.


          </li>
        </ul>
      </div>
    </section>
  )
}
